import ErrorPage from "./ErrorPage";

/**
 * Backwards-compatible Avida 403 page. Delegates to the unified ErrorPage
 * so all error codes share the same witty, branded look.
 */
export default function Forbidden403({ title, message, reason = "" }) {
  return (
    <ErrorPage code={403} title={title} message={message} reason={reason} />
  );
}
